<template>
  <Transition name="fade">
    <div
      v-if="show"
      class="fixed inset-0 bg-slate-900/60 backdrop-blur-md z-[100] flex items-center justify-center p-6"
      @click.self="emit('close')"
    >
      <div class="bg-white rounded-[2.5rem] p-10 max-w-2xl w-full shadow-2xl scale-up max-h-[80vh] overflow-y-auto">
        <div class="flex justify-between items-center mb-8">
          <h2 class="text-2xl font-extrabold text-slate-900">Nouveau Composant</h2>
          <button @click="emit('close')" class="text-2xl text-slate-300 hover:text-slate-500">✕</button>
        </div>
        <div class="grid grid-cols-3 gap-6">
          <button
            v-for="blockType in blockTypes"
            :key="blockType.id"
            @click="emit('select', blockType.id)"
            class="flex flex-col items-center gap-4 p-8 rounded-[2rem] border-2 border-slate-50 hover:border-indigo-500 hover:bg-indigo-50 transition-all"
          >
            <span class="text-5xl">{{ blockType.icon }}</span>
            <span class="font-bold text-slate-700 text-sm text-center">{{ blockType.label }}</span>
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
defineProps({
  show: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['close', 'select']);

const blockTypes = [
  { id: 'text', label: 'Texte', icon: '✍️' },
  { id: 'image', label: 'Image', icon: '🖼️' },
  { id: 'language_button', label: 'Bouton Langue', icon: '🌐' },
  { id: 'button', label: 'Bouton URL', icon: '🔘' },
  { id: 'rectangle', label: 'Rectangle', icon: '▭' },
  { id: 'circle', label: 'Cercle', icon: '●' },
  { id: 'triangle', label: 'Triangle', icon: '▲' },
  { id: 'video', label: 'Vidéo iFrame', icon: '🎬' }
];
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.scale-up {
  animation: scale-up 0.2s ease;
}

@keyframes scale-up {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
